import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const subscriptionRoutes: RouteRecordRaw[] = [
  // Subscription Types - now redirect to products (subscriptions are products)
  {
    path: '/subscription-types',
    name: 'subscription-types',
    // Redirect to products filtered by subscription type
    redirect: { name: 'products', query: { type: 'subscription' } }
  },
  {
    path: '/subscription-types/create',
    name: 'subscription-type-create',
    // Redirect to products list (create/edit now handled via slide-over)
    redirect: { name: 'products', query: { type: 'subscription' } }
  },
  {
    path: '/subscription-types/:id/edit',
    name: 'subscription-type-edit',
    // Redirect to products list (create/edit now handled via slide-over)
    redirect: { name: 'products' }
  },
  // Field Definitions (generic - for customer, product, order)
  {
    path: '/field-definitions',
    name: 'field-definitions',
    component: () => import('@/modules/subscriptions/views/FieldDefinitionListView.vue'),
    meta: {
      permission: PERMISSIONS.PROJECT.SETTINGS,
      projectScoped: true
    }
  },
  // Backward compatible redirects for customer fields
  {
    path: '/customer-fields',
    name: 'customer-fields',
    redirect: { name: 'field-definitions', query: { entityType: 'customer' } }
  },
  {
    path: '/customer-fields/create',
    name: 'customer-field-create',
    redirect: { name: 'field-definitions', query: { entityType: 'customer' } }
  },
  {
    path: '/customer-fields/:id/edit',
    name: 'customer-field-edit',
    redirect: { name: 'field-definitions', query: { entityType: 'customer' } }
  }
]
